import {
  Disclaimer,
  DisclaimerPositioning,
  FundReturnKey,
  Product,
  ProductCenterExhibit,
  SortDirection,
  SortField,
  View,
} from '../product-center-table-wrapper/product-center-table-wrapper.model';

export enum TableTypeEnum {
  PERFORMANCE = 'performance',
  PRICE = 'price',
  ESG = 'esg',
  DOCUMENTS = 'documents',
  TILE_VIEW = 'tileView',
}

export enum TileTabEnum {
  ONE_YEAR = 'oneYear',
  THREE_YEARS = 'threeYears',
  FIVE_YEARS = 'fiveYears',
  TEN_YEARS = 'tenYears',
  SINCE_INCEPTION = 'sinceInception',
}

export enum FilterCategoryField {
  PRODUCT_RANGE = 'vehicleTypeName',
  ASSET_CLASS = 'investmentStrategiesAssetClassName',
  GEOGRAPHICAL_EXPOSURE = 'investmentStrategiesRegionName',
  DISTRIBUTION_FREQUENCY = 'declarationFrequencyName',
}

export enum TableFieldEnum {
  PERFORMANCE_TABLE = 'performanceTable',
  PRICE_TABLE = 'priceTable',
  ESG_TABLE = 'esgTable',
  DOCUMENTS_TABLE = 'documentsTable',
}

export type IGroupedFunds = {
  parentProductCode: Product['parentProductCode'];
  products: Product['productCode'][];
};

export type ISelectedProductFromGroup = {
  parentProductCode: Product['parentProductCode'];
  productCode: Product['productCode'];
};

export type IPerformanceTileView = {
  sortField: SortField;
  sortDirection: SortDirection;
  selectedTab: number;
  currentFundReturnKey: FundReturnKey;
  productsGroup: IGroupedFunds[];
  selectedProductFromGroup: ISelectedProductFromGroup[];
  selectedProducts: ISelectedProductsTileView;
};

export type ITableSortFirstColumn = {
  [TableFieldEnum.PERFORMANCE_TABLE]: string;
  [TableFieldEnum.PRICE_TABLE]: string;
  [TableFieldEnum.ESG_TABLE]: string;
  [TableFieldEnum.DOCUMENTS_TABLE]: string;
};

export type ISelectedProductsTableView = {
  [TableTypeEnum.PERFORMANCE]: Product['productCode'][];
  [TableTypeEnum.PRICE]: Product['productCode'][];
  [TableTypeEnum.ESG]: Product['productCode'][];
  [TableTypeEnum.DOCUMENTS]: Product['productCode'][];
  [TableTypeEnum.TILE_VIEW]: Product['productCode'][];
};

export type ISelectedProductsTileView = {
  [TileTabEnum.ONE_YEAR]: Product['productCode'][];
  [TileTabEnum.THREE_YEARS]: Product['productCode'][];
  [TileTabEnum.FIVE_YEARS]: Product['productCode'][];
  [TileTabEnum.TEN_YEARS]: Product['productCode'][];
  [TileTabEnum.SINCE_INCEPTION]: Product['productCode'][];
};

export type FilteredProducts = {
  parentProductCode: Product['parentProductCode'];
  productCode: Product['productCode'];
};

export type IFilter = {
  categoryField: FilterCategoryField;
  filterValue: string;
};

export type IFilters = {
  [key in FilterCategoryField]?: ICategoryFilterData[];
};
export type IURLFilterList = {
  [FilterCategoryField.PRODUCT_RANGE]?: string[];
  [FilterCategoryField.ASSET_CLASS]?: string[];
  [FilterCategoryField.GEOGRAPHICAL_EXPOSURE]?: string[];
  [FilterCategoryField.DISTRIBUTION_FREQUENCY]?: string[];
};

export type ICategoryFilterData = {
  name: string;
  count: number;
  isSelected: boolean;
};

export type IDownloadProductsData = {
  totalProducts: number;
  isAllProductSelected: boolean;
  selectedProductsField: TableTypeEnum | TileTabEnum;
};

export type IProductCenterStore = {
  storeInitialized: boolean;
  originalProductCenterObject: ProductCenterExhibit;
  filters: IFilters;
  filteredProducts: FilteredProducts[];
  filteredProductsShown: number;
  selectedView: View;
  performanceTileView: IPerformanceTileView;
  selectedTabInTableView: number;
  searchTerm: string;
  selectedProducts: ISelectedProductsTableView;
  toggleCheckProduct: (
    selectedProductsField: TableTypeEnum | TileTabEnum,
    productCode: Product['productCode'],
    shouldAdd: boolean,
  ) => void;
  toggleCheckAllProducts: (
    selectedProductsField: TableTypeEnum | TileTabEnum,
  ) => void;
  getSelectedProductFromGroup: (
    parentProductCode: Product['productCode'],
  ) => Product['productCode'];
  getFilteredProducts: () => Product[];
  getProductsGroup: (parentProductCode: Product['productCode']) => Product[];
  getFilteredProductsShown: () => number;
  setFilteredProducts: (filterBy?: IFilter) => void;
  setFilteredProductsFromURLParams: (urlParams: URLSearchParams) => void;
  resetFilters: (categoryField?: FilterCategoryField) => void;
  getDisclaimersByPositioning: (
    positioning: DisclaimerPositioning,
  ) => Disclaimer[];
  getDownloadProductsData: () => IDownloadProductsData;
  setOriginalProductCenterObject: (
    productCenterObject: ProductCenterExhibit,
    classLabel?: string,
  ) => void;
  setSelectedView: (selectedView: View) => void;
  setSortInTileView: (
    sortField: SortField | undefined,
    sortDirection: SortDirection | undefined,
  ) => void;
  setSearchTerm: (
    searchTerm: string | undefined,
    customSearch?: {
      searchAllProducts?: boolean;
    },
  ) => void;
  setSelectedProductFromGroup: (
    parentProductCode: Product['productCode'],
    productCode: Product['productCode'],
  ) => void;
  tabChangeHandler: (tabIndex: number) => void;
};
